const sidebar = false;

const entity = {
  title: "Courses",
  actions: {
    sort: {
      endPoint: "courses/by",
      query: {
        $order: {},
      }
    },
    get: {
      endPoint: "courses/by",
      query: {}
    },
    create: {
      endPoint: "courses"
    },
    filter: {
      endPoint: "courses/by",
      query: {
        $group: "id",
        $where: {}
      }
    }
  }
};

const keys = [{
  dataTableID: "id",
  tooltip: "ID to generate this report",
  label: "Id",
  columnType: "string",
  table: {
    displayOrder: 1
  },
  filter: {
    displayOrder: 1,
    columnType: "selectWithQuery",
    matchType: "", // Values can be gte, lte, gt, lt, By default it is eq
    options: {
      select: [{
        field: "id"
      }],
      title: ["id"],
      value: "id",
      endPoint: "courses/by",
      separator: " ",
      initializer: "",
      query: {
        $where: {
          id: "$input"
        }
      },
      keyFinder: "$input"
    }
  }
},
{
  dataTableID: "title",
  tooltip: "Title of the course",
  label: "Title",
  columnType: "string",
  create: {
    displayOrder: 1
  },
  table: {
    displayOrder: 2
  },
  filter: {
    displayOrder: 2
  }
},
{
  dataTableID: "description",
  tooltip: "Description of the course",
  label: "Description",
  columnType: "string",
  create: {
    displayOrder: 2
  },
  table: {
    displayOrder: 3
  }
}
];

const tabs = [{
  view: "detailView",
  entity: "academies",
  endPoint: "courses/by",
  title: "Details",
  queryFilter: {
    id: ":id"
  }
}];

export {
  sidebar,
  entity,
  keys,
  tabs
};